import { ResolveFunction, ResolveOptions } from './resolve-function-registry';

const DEFAULT_POLL_MS = 500;
const FAST_POLL_MS = 50;

/**
 * Ask the app-level resolver for an entity and wait until its batched resolve call has settled.
 * The resolver flags itself as busy through a localStorage key, which is what we poll here.
 */
export async function awaitResolve(id: string, resolveFunction: ResolveFunction, options?: ResolveOptions): Promise<void> {
    const key = resolveFunction(id, options);
    if (!options?.skipTimeout) {
        await new Promise((resolve) => setTimeout(resolve, DEFAULT_POLL_MS));
    }
    const pollMs = options?.skipTimeout ? FAST_POLL_MS : DEFAULT_POLL_MS;
    let value = localStorage.getItem(key);
    while (value != null && JSON.parse(value) === true) {
        await new Promise((resolve) => setTimeout(resolve, pollMs));
        value = localStorage.getItem(key);
    }
}
